type ToastIdSegment = string | number;

const joinToastId = (...segments: readonly ToastIdSegment[]): string => segments.map(String).join(':');

export const TOAST_IDS = {
    reviewAnswerJobsOfferNotAccepted: 'review-answer-jobs:offer-not-accepted',
    reviewSelectionLimitReached: 'review-selection:limit-reached',
    groupSelectionLimitReached: 'group-selection:limit-reached',
    answerPickLoadSelectionLimitWarning: 'answer-pick:load-selection:limit-warning',
    answerPickCreateAnswersLimitWarning: 'answer-pick:create-answers:limit-warning',
    answerPickCreateAnswersSkipped: 'answer-pick:create-answers:skipped',
} as const;

export const createClientSyncQuotaToastId = ({ clientId, platform }: { clientId: string; platform: string }): string =>
    joinToastId('client-sync', clientId, platform, 'quota-exhausted');

export const createReviewAiAnswerToastId = ({
    operationId,
    outcome,
}: {
    operationId: string;
    outcome: 'canceled';
}): string => joinToastId('review-ai-answer', operationId, outcome);

export const createBillingPaymentToastId = ({
    notificationId,
    outcome,
}: {
    notificationId: string;
    outcome: 'success' | 'pending' | 'refresh-failed' | 'failed';
}): string => joinToastId('billing-payment', notificationId, outcome);

export const createAiAnalysisToastId = ({
    operationId,
    outcome,
}: {
    operationId: string;
    outcome: 'limit-warning' | 'start-failed' | `terminal:${string}`;
}): string => joinToastId('ai-analysis', operationId, outcome);

export const createCsvExportToastId = ({
    operationId,
    outcome,
}: {
    operationId: string;
    outcome: 'limit-warning';
}): string => joinToastId('csv-export', operationId, outcome);
